import { useQuery } from 'react-query';

import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';

const { CONTROLLERS: { PLAID }, BASE: USER_BASE } = USER;

const { ROUTES: { LINKED_ACCOUNTS: { VERSION, BASE: GENERATE_BASE } } } = PLAID;

interface IProps {
    publicToken: string;
    institutionId: string;
    metaDataStr: string;
}

export const useSetLinkAccount = (customerId: string, { publicToken, institutionId, metaDataStr }: IProps) => useQuery(
  'setLinkAccount',
  async () => {
    if (!customerId) {
      return null;
    }
    const { data } = await httpService.post((`${BASE_URL}/${USER_BASE.replace('{version}', VERSION)}/${customerId}/${GENERATE_BASE}`), {
      publicToken, institutionId, metaData: metaDataStr,
    });
    return data;
  },
  {
    enabled: false,
  },
);
